import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const Resources = makeShortcode("Resources");
const DiscoverBlock = makeShortcode("DiscoverBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Hero slots="image, heading, text" mdxType="Hero" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "18.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/experience-cloud/cloud-manager/static/e7b97f7d15ccaf4e83ef6dfbaa44ca67/5530d/pipeline-illustration.webp 320w", "/experience-cloud/cloud-manager/static/e7b97f7d15ccaf4e83ef6dfbaa44ca67/0c8fb/pipeline-illustration.webp 640w", "/experience-cloud/cloud-manager/static/e7b97f7d15ccaf4e83ef6dfbaa44ca67/94b1e/pipeline-illustration.webp 1280w", "/experience-cloud/cloud-manager/static/e7b97f7d15ccaf4e83ef6dfbaa44ca67/0b34d/pipeline-illustration.webp 1920w", "/experience-cloud/cloud-manager/static/e7b97f7d15ccaf4e83ef6dfbaa44ca67/da4f1/pipeline-illustration.webp 2494w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/experience-cloud/cloud-manager/static/e7b97f7d15ccaf4e83ef6dfbaa44ca67/dd4a7/pipeline-illustration.png 320w", "/experience-cloud/cloud-manager/static/e7b97f7d15ccaf4e83ef6dfbaa44ca67/0f09e/pipeline-illustration.png 640w", "/experience-cloud/cloud-manager/static/e7b97f7d15ccaf4e83ef6dfbaa44ca67/bbbf7/pipeline-illustration.png 1280w", "/experience-cloud/cloud-manager/static/e7b97f7d15ccaf4e83ef6dfbaa44ca67/ac7a9/pipeline-illustration.png 1920w", "/experience-cloud/cloud-manager/static/e7b97f7d15ccaf4e83ef6dfbaa44ca67/9ac23/pipeline-illustration.png 2494w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/experience-cloud/cloud-manager/static/e7b97f7d15ccaf4e83ef6dfbaa44ca67/bbbf7/pipeline-illustration.png",
            "alt": "Hero image",
            "title": "Hero image",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h1 {...{
      "id": "adobe-cloud-manager"
    }}>{`Adobe Cloud Manager`}</h1>
    <p>{`Cloud Manager enables organizations to self-manage Adobe Experience Manager environments in the cloud -- both Adobe Managed Services and Adobe Experience Manager Cloud Service.`}</p>
    <Resources slots="heading, links" mdxType="Resources" />
    <h4 {...{
      "id": "resources"
    }}>{`Resources`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.com/go/aem_cloud_mgr_userguide_en"
        }}>{`Cloud Manager Documentation - Managed Services`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.com/go/aem_cloud_serv_implement__en"
        }}>{`Cloud Manager Documentation - AEM Cloud Service`}</a></li>
    </ul>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`Cloud Manager includes a full-featured web user interface at `}<a parentName="p" {...{
        "href": "https://my.cloudmanager.adobe.com/"
      }}>{`https://my.cloudmanager.adobe.com/`}</a>{`. The Cloud Manager API enables Cloud Manager customers to interact with many of the same underlying capabilities exposed through the web UI in a fully programmatic fashion. This allows for integration of the Cloud Manager Continuous Integration / Continuous Delivery pipeline with other systems.`}</p>
    <p>{`General information on Cloud Manager can be found in the Product Documentation in the Resources section.`}</p>
    <p>{`The links in this documentation will guide you through getting started with the Cloud Manager API. There is also a complete `}<a parentName="p" {...{
        "href": "reference/api.md"
      }}>{`API Reference`}</a>{` which describes all of the individual endpoints and requests which are available for usage.`}</p>
    <h2 {...{
      "id": "discover"
    }}>{`Discover`}</h2>
    <DiscoverBlock slots="heading, link, text" mdxType="DiscoverBlock" />
    <h3 {...{
      "id": "guides"
    }}>{`Guides`}</h3>
    <p><a parentName="p" {...{
        "href": "guides/getting-started/create-api-integration.md"
      }}>{`Creating an API Integration Project`}</a></p>
    <p>{`Learn how to create an API Integration Project`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "guides/getting-started/create-event-integration.md"
      }}>{`Creating an Event Integration Project`}</a></p>
    <p>{`Learn how to create an Event Integration Project to receive webhooks when your pipelines execute.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "guides/getting-started/permissions.md"
      }}>{`Permissions`}</a></p>
    <p>{`See which permissions are required for using the API.`}</p>
    <DiscoverBlock slots="link" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "guides/"
      }}>{`All Guides`}</a></p>
    <DiscoverBlock slots="heading, link, text" mdxType="DiscoverBlock" />
    <h3 {...{
      "id": "detailed-api-information"
    }}>{`Detailed API Information`}</h3>
    <p><a parentName="p" {...{
        "href": "reference/api.md"
      }}>{`Complete API Reference`}</a></p>
    <p>{`See the full API Reference.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "reference/events.md"
      }}>{`Event Definitions`}</a></p>
    <p>{`See the definitions of events sent from Cloud Manager.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "reference/playground.md"
      }}>{`API Playground`}</a></p>
    <p>{`Make API calls from your browser.`}</p>
    <DiscoverBlock width="100%" slots="heading, link, text" mdxType="DiscoverBlock" />
    <h3 {...{
      "id": "tutorial"
    }}>{`Tutorial`}</h3>
    <p><a parentName="p" {...{
        "href": "tutorial/"
      }}>{`Tutorial`}</a></p>
    <p>{`Walk through a step-by-step tutorial`}</p>
    <DiscoverBlock width="100%" slots="heading, link, text" mdxType="DiscoverBlock" />
    <h3 {...{
      "id": "cli-and-sdks"
    }}>{`CLI and SDKs`}</h3>
    <p><a parentName="p" {...{
        "href": "cli-and-sdks/"
      }}>{`CLI and SDKs`}</a></p>
    <p>{`Learn about the Cloud Manager CLI and the available SDKs for easy project integration.`}</p>
    <h2 {...{
      "id": "contributing"
    }}>{`Contributing`}</h2>
    <p>{`We encourage you to participate in our open documentation initiative, if you have suggestions, corrections, additions or deletions for this documentation, check out the source from `}<a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/cloudmanager-api-docs"
      }}>{`this github repo`}</a>{`, create issues, and submit pull requests with your contribution.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      